import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SITE = {
  name: "Indapur FPC",
  fullName: "Indapur Farmers Producer Company Limited",
  tagline: "Empowering Farmers, Growing Together",
  phone: "+91 8600080860",
  whatsapp: "8600080860",
  email: "fpo@indapuragro.com",
  address: "Indapur, Pune, Maharashtra - 413106",
  whatsappLink: "https://wa.me/918600080860",
};
